import { render, staticRenderFns } from "./lectureRegistration.vue?vue&type=template&id=4313c63c&scoped=true"
import script from "./lectureRegistration.vue?vue&type=script&lang=js"
export * from "./lectureRegistration.vue?vue&type=script&lang=js"
import style0 from "./lectureRegistration.vue?vue&type=style&index=0&id=4313c63c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4313c63c",
  null
  
)

export default component.exports